// extracted by mini-css-extract-plugin
export default {"buttongroup":"ButtonGroup_buttongroup__NpXJo"};